export class Address {
	public addressId?: number;
	public line1: string;
	public line2: string;
	public city: string;
	public stateId: number;
	public stateCode?: string;
	public stateName?: string;
	public zipCode: string;
	public isGeoCodingNeeded: boolean;
	public countryId: number;
	public latitude?: number;
	public longitude?: number;
	public code2: string;
}


export class AddressModel {
	public addressId?: number;
	public line1 = '';
	public line2 = '';
	public city = '';
	public stateId: number;
	public stateCode: string;
	public stateName: string;
	public zipCode = '';
	public countryId: number;
	public isPartial = false;
	public longitude: number;
	public latitude: number;
	public code2: string;
	public country: string;
	public countryCode: string;
	public details: string;
}
